export { FilePicker as default } from './FilePicker.component';
export type { FilePickerProps } from './FilePicker.props';
export const FILEPICKER_ID = 'FILEPICKER_ID';
